<template>
  <div class="uk-overflow-auto uk-margin">
    <table class="uk-table uk-table-middle uk-table-small uk-table-hover uk-table-divider">
      <thead>
        <tr>
          <th class="uk-table-shrink">
            <div class="uk-button-group checkbox">
              <div>
                <!--
                <label>
                  <input class="uk-checkbox" type="checkbox" @click="selectAll" v-model="allSelected" />
                </label>
                -->
              </div>
            </div>
          </th>
          <th class="uk-table-expand">Name</th>
          <th class="uk-width-small uk-text-nowrap uk-text-right">B2B-VK netto</th>
          <th class="uk-table-shrink uk-text-nowrap uk-text-right">Erstellt am</th>
          <th style="width: 25px"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in packages" :key="item.id">
          <td class="uk-text-nowrap">
            <label>
              <input class="uk-checkbox" type="checkbox" :value="item.id" v-model="checked" />
            </label>
          </td>
          <td @click.prevent="$emit('openModal', item)">{{ item.name }} <span class="uk-text-muted uk-text-small">({{ item.vehicleIds.length }} Fahrzeuge)</span></td>
          <td class="uk-text-right" @click.prevent="$emit('openModal', item)">
            {{ item.priceFormatted }}
          </td>
          <td class="uk-text-right" @click.prevent="$emit('openModal', item)">{{ item.createdAt }}</td>
          <td class="uk-text-nowrap">
            <div>
              <a href="#" class="uk-icon-link" uk-icon="more"></a>
              <div data-uk-dropdown="mode: click;animation: uk-animation-slide-top-small;">
                <ul class="uk-nav uk-dropdown-nav uk-text-left">
                  <li>
                    <a href="#" class="uk-dropdown-close" @click.prevent="$emit('openModal', item)">
                      Bearbeiten
                    </a>
                  </li>
                  <li class="uk-nav-divider uk-margin-remove"></li>
                  <li>
                    <a class="uk-text-danger uk-dropdown-close" href="#" @click.prevent="remove(item.id)">
                      <span class="uk-icon" data-uk-icon="icon: trash"></span>&nbsp; Löschen
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import PackageService from '@/services/package.service'
import 'izitoast/dist/css/iziToast.min.css'
import iziToast from 'izitoast/dist/js/iziToast.min.js'
export default {
  props: {
    packages: { required: true }
  },
  data() {
    return {
      meta: null,
      checked: [],
      allSelected: false
    }
  },
  mounted() {},
  watch: {
    checked() {
      this.$emit('input', this.checked)
    }
  },
  methods: {
    selectAll() {
      this.checked = []
      if (!this.allSelected) {
        for (let item in this.packages) {
          this.checked.push(this.packages[item].id)
        }
      }
    },
    addSelected(id) {
      if (this.checked.includes(id)) {
        const index = this.checked.indexOf(id)
        this.checked.splice(index, 1)
      } else {
        this.checked.push(id)
      }
    },
    remove(id) {
      const $this = this
      this.$uikit.modal
        .confirm('Paket wirklich löschen?', {
          labels: {
            cancel: 'Abbrechen',
            ok: 'Löschen'
          }
        })
        .then(function() {
          PackageService.delete(id)
            .then(() => {
              $this.$emit('deleted')
              iziToast.success({
                title: 'OK',
                message: 'Paket gelöscht!',
                timeout: 3000,
                position: 'topCenter'
              })
            })
            .catch(() => {
              iziToast.error({
                title: 'OK',
                message: 'Löschen fehlgeschlagen!',
                timeout: 3000,
                position: 'topCenter'
              })
            }),
            function() {
              //
            }
        })
    },
  }
}
</script>
<style lang="scss">
tr {
  &:hover {
    cursor: pointer;
  }
  &.highlight {
    background: #edf2f6 !important;
  }
}
</style>
